const unspaceString = (value) => value.replace(/\s+/g, "");
export {
  unspaceString as default
};
//# sourceMappingURL=unspace-string.js.map
